import {Space} from 'antd';
import styled from 'styled-components';
import {typographyStyles} from "../../../../utils/styles";

const StyledBudgetRequestInfo = styled(Space)`
  width: 100%;
  font-size: 14px;

  .ant-divider-horizontal {
    margin: 0;
  }
`;

const StyledBudgetRequestInfoSpace = styled(Space)`
  width: 100%;
  & > .ant-space-item {
    width: 100%;
  }
`;

const StyledBudgetRequestInfoTitle = styled.div`
  ${typographyStyles.body.medium};
  color: ${props => props.theme.colors.neutral_7};

  .anticon {
    margin-left: 4px;
    font-size: 14px;
  }
`;

export {
  StyledBudgetRequestInfo,
  StyledBudgetRequestInfoSpace,
  StyledBudgetRequestInfoTitle,
}
